module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-04.05995b41.png";